import { CampaignStateDefinition, GRAPHQL_TYPENAMES } from 'modules/graphql';
import {
  ListReference,
  ListReferredByCampaign,
  ListReferredByJourney,
  ListReferredByList,
} from '../../../types';

export const getListUrl = (listReference: ListReferredByList) =>
  `/segmentation?emailListId=${listReference.id}`;

export const getCampaignUrl = (listReference: ListReferredByCampaign) => {
  switch (listReference.campaignState) {
    case CampaignStateDefinition.Draft:
    case CampaignStateDefinition.Ready:
      return `/templates/edit?templateId=${listReference.templateId}&campaignId=${listReference.id}`;
    case CampaignStateDefinition.Scheduled:
      return `/campaigns/review?campaignId=${listReference.id}`;
    default:
      return `/analytics/campaignPerformance?campaignId=${listReference.id}`;
  }
};

export const getJourneyUrl = (listReference: ListReferredByJourney) =>
  `/workflows/${listReference.id}/edit?workflowType=${listReference.workflowType}`;

export const getListReferenceUrl = (listReference: ListReference) => {
  switch (listReference.__typename) {
    case GRAPHQL_TYPENAMES.LIST:
      return getListUrl(listReference);
    case GRAPHQL_TYPENAMES.CAMPAIGN:
      return getCampaignUrl(listReference);
    case GRAPHQL_TYPENAMES.JOURNEY:
      return getJourneyUrl(listReference);
    default:
      return '#';
  }
};
